import { actionTree } from 'typed-vuex';
import initialState from '@/store/modules/global/state';
import mutations from '@/store/modules/global/mutations';
import getters from './getters';

const actions = actionTree(
  { state: initialState, getters, mutations },
  {
    showSpinner({ commit }) {
      commit('SHOW_SPINNER');
    },
    hideSpinner({ commit }) {
      commit('HIDE_SPINNER');
    },
    toggleDrawer({ commit }, payload: boolean) {
      commit('TOGGLE_DRAWER', payload);
    },
    showErrorPopup({ commit }, errorMsgKey: string) {
      if (typeof errorMsgKey === 'string') {
        commit('ADD_ERROR_MSG', errorMsgKey);
      }
    },
    closeErrorPopup({ commit }, errorMsgIndex: number) {
      if (typeof errorMsgIndex === 'number' && errorMsgIndex >= 0) {
        commit('REMOVE_ERROR_MSG', errorMsgIndex);
      }
    },
    setSearchInput({ commit }, payload: string) {
      commit('ADD_SEARCH_INPUT', payload);
    },
  },
);

export default actions;
